export default __webpack_public_path__ + "static/media/background.8d5f6573.jpg";